import { mainnet } from 'wagmi/chains'
import useSWR from 'swr'
import { useAccount } from 'wagmi'
import { truncateAddress, truncateEns } from '@/utils/truncate'
import { client } from '@/utils/sanity'
import { useState, useEffect } from 'react'

export default (address?: string, chainId: number = 1) => {
  const { address: accountAddress } = useAccount()
  const addressLowercase = address?.toLowerCase()
  const [userData, setUserData] = useState({ firstName: '', profileSrc: '' })
  const isENSAvailable = chainId === mainnet.id
  const isAccountAddress =
    accountAddress && address?.toLowerCase() === accountAddress?.toLowerCase()

  const getProfileDta = async (sanityClient = client) => {
    const query = `*[_type == "users" && _id == "${address?.toLowerCase()}" ] {
          firstName, 
          profileSrc
        }`

    await sanityClient
      .fetch(query)
      .then((result) => {
        const userData = result[0]
        if (userData !== undefined && userData !== null) { 
          setUserData(userData)
        }
      })
      .catch((err) => {
        console.error('Delete failed: ', err.message)
      })
  }
  useEffect(() => {
    ; (async () => { 
      if (userData?.firstName == '') { 
        await getProfileDta(client)
      }
    })()
  }, [userData])

  const response = useSWR(
    `https://api.ensideas.com/ens/resolve/${addressLowercase}`,
    (url: string) => {
      if (!isENSAvailable || !address) {
        return null
      }
      return fetch(url).then((response) => response.json())
    },
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
    }
  )

  const shortAddress = address ? truncateAddress(address) : ''
  const shortName = response.data?.name ? truncateEns(response.data.name) : null
  let displayName = ''

  if (isAccountAddress) {
    displayName = 'You'
  } else if (response.data?.name) {
    displayName = shortName || ''
  } else if (address) {
    displayName = shortAddress
  } 
  return {
    ...response,
    address,
    name: response.data?.name,
    shortName,
    displayName,
    shortAddress,
    avatar: response.data?.avatar,
    userName: userData?.firstName,
    profilePic: userData?.profileSrc,
  }
}
